<div [formGroup]="form" *ngIf="form" class="form-responsive"
    (keydown.tab)="$event.stopPropagation()"
    (click)="$event.stopPropagation()">
    <div class="form-group">
        <mat-form-field appearance="outline" class="min-width">
            <mat-label>Nome da categoria</mat-label>
            <input type="text" #nomeInput placeholder="Ex.: Ferragens, Mão de obra" matInput
                formControlName="title" required maxlength="191">
            <mat-error *ngIf="form.get('title')?.hasError('required')">Informe o nome</mat-error>
        </mat-form-field>
    </div>

    <!-- Fora de diálogo (uso direto na página) -->
    <div *ngIf="!inDialog" class="form-actions">
        <button *ngIf="!productCategory?.id" type="button" class="oa-btn oa-btn--primary"
            [disabled]="loading || !form.dirty || !form.valid" [attr.aria-busy]="loading || null" (click)="store()">
            <span>Criar categoria</span>
            <span *ngIf="loading" class="oa-spinner" aria-hidden="true"></span>
        </button>
        <button *ngIf="productCategory?.id" type="button" class="oa-btn oa-btn--primary"
            [disabled]="loading || !form.dirty || !form.valid" [attr.aria-busy]="loading || null" (click)="update()">
            <span>Salvar alterações</span>
            <span *ngIf="loading" class="oa-spinner" aria-hidden="true"></span>
        </button>
    </div>
</div>
